import tippy from "tippy.js";
class Tooltip {
    tippy = undefined;

    constructor(el) {
        this.el = el;
        this.tippy = tippy(this.el, {
            content: this.el.dataset.tooltipText || this.el.innerHTML,
            allowHTML: true,
            placement: "top",
            popperOptions: {
                strategy: "fixed",
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: ["top", "right", "left"],
                        },
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            altAxis: true,
                            tether: false,
                        },
                    },
                ],
            },
        });
    }

    createTooltip() {
        const tooltipNode = document.createElement("span");
        tooltipNode.className = "tooltip js-tooltip";
        tooltipNode.innerHTML = this.el.dataset.tooltipText;
        this.el.append(tooltipNode);
        this.isTooltipCreated = true;
    }
}

window.addEventListener(
    "load",
    document.querySelectorAll(".js-tooltip-text").forEach((node) => new Tooltip(node))
);
